import {
  REGISTRATE_USER_SUCCESS,
  REGISTRATE_USER_ERROR,
  CLEAR_REGISTRATE_USER,
  VERIFY_REGISTRATION_EMAIL_SUCCESS,
  VERIFY_REGISTRATION_EMAIL_ERROR,
  LOGGED_IN,
  LOGIN_ERROR,
  CLEAR_LOGIN_ERROR,
  UNAUTHORIZED,
  RESET_UNAUTHORIZED,
  FETCH_ME,
  FETCH_ME_ERROR,
  LOGGING_OUT,
  LOGGED_OUT,
  REFRESH_TOKEN,
  REFRESH_TOKEN_ERROR,
  SEND_PASSWORD_RESET_LINK_SUCCESS,
  SEND_PASSWORD_RESET_LINK_ERROR,
  CLEAR_SEND_PASSWORD_RESET_LINK,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  CLEAR_RESET_PASSWORD,
  CONFIRMATION_RESENT_SUCCESS,
  CONFIRMATION_RESENT_ERROR,
  CLEAR_CONFIRMATION_RESENT,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_ERROR,
  SOCIAL_LOGIN,
  SOCIAL_LOGIN_ERROR,
  ADMIN_SET_TOKENS,
  TOGGLE_LIVECHAT,
  SET_ME,
  CHANGE_SHORT_USERNAME_SUCCESS,
  CHANGE_SHORT_USERNAME_ERROR,
  CLEAR_CHANGE_SHORT_USERNAME,
  GENERATE_QRCODE_USER_SUCCESS,
  GENERATE_QRCODE_USER_ERROR,
  CLEAR_GENERATE_QRCODE_USER,
  FETCH_PAGE_BLOCK_ITEMS_LIST,
  FETCH_PAGE_BLOCK_ITEMS_LIST_ERROR,
  CLEAR_FETCH_PAGE_BLOCK_ITEMS_LIST,
  APPLY_PAGE_BLOCK_ITEM_DRAG,
  APPLY_PAGE_BLOCK_ITEM_DRAG_ERROR,
  CLEAR_APPLY_PAGE_BLOCK_ITEM_DRAG,
  CHANGE_EMAIL_SUCCESS,
  CHANGE_EMAIL_ERROR,
  CLEAR_CHANGE_EMAIL,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  CLEAR_CHANGE_PASSWORD,
  CREATE_TOTP_SUCCESS,
  CREATE_TOTP_ERROR,
  CLEAR_CREATE_TOTP,
  DELETE_TOTP_SUCCESS,
  DELETE_TOTP_ERROR,
  CLEAR_DELETE_TOTP,
  FETCH_TWFA_QRCODE_SUCCESS,
  FETCH_TWFA_QRCODE_ERROR,
  CLEAR_FETCH_TWFA_QRCODE,
  ENABLE_TOTP_SUCCESS,
  ENABLE_TOTP_ERROR,
  CLEAR_ENABLE_TOTP,
  FETCH_TWFA_ENABLED_SUCCESS,
  FETCH_TWFA_ENABLED_ERROR,
  CLEAR_FETCH_TWFA_ENABLED,
  VALIDATE_USERNAME_SUCCESS,
  VALIDATE_USERNAME_ERROR,
  CLEAR_VALIDATE_USERNAME,
  SET_LANG_SUCCESS,
  SET_LANG_ERROR,
} from 'redux/users/types';
import { checksum } from 'shared/checksum.js';

const initialState = {
  me: null,
  meError: null,
  registrateUserSuccess: null,
  registrateUserError: null,
  verifyRegistrationEmailSuccess: false,
  verifyRegistrationEmailError: null,
  accessToken: null,
  refreshToken: null,
  isRegistered: null,
  loginError: null,
  loggingOut: false,
  unauthorized: false,
  refreshTokenError: null,
  sendPasswordResetLinkSuccess: null,
  sendPasswordResetLinkError: null,
  resetPasswordSuccess: null,
  resetPasswordError: null,
  confirmationResentSuccess: null,
  confirmationResentError: null,
  countries: null,
  countriesError: null,
  liveChatEnabled: true,
  changeShortUsernameSuccess: null,
  changeShortUsernameError: null,
  userQrCodeGeneratedSuccess: null,
  userQrCodeGeneratedError: null,
  pageBlockItemsList: null,
  pageBlockItemsListError: null,
  pageBlockItemsDragSuccess: null,
  pageBlockItemsDragError: null,
  changeEmailSuccess: null,
  changeEmailError: null,
  changePasswordSuccess: null,
  changePasswordError: null,
  createTtopSuccess: null,
  createTtopError: null,
  deleteTtopSuccess: null,
  deleteTtopError: null,
  twoFactorCode: null,
  twoFactorCodeError: null,
  enableTotpSuccess: null,
  enableTotpError: null,
  twoFaEnabled: null,
  twoFaEnabledError: null,
  validateUsernameSuccess: null,
  validateUsernameError: null,
};


export default (state = initialState, action) => {
  switch (action.type) {
    case REGISTRATE_USER_SUCCESS:
      return {
        ...state,
        registrateUserSuccess: action.payload.data,
        registrateUserError: null,
      };
    case REGISTRATE_USER_ERROR:
      return {
        ...state,
        registrateUserSuccess: null,
        registrateUserError: action.payload.data,
      };
    case CLEAR_REGISTRATE_USER:
      return {
        ...state,
        registrateUserSuccess: null,
        registrateUserError: null,
      };
    case VERIFY_REGISTRATION_EMAIL_SUCCESS:
      return {
        ...state,
        accessToken: action.payload.data.access_token,
        refreshToken: action.payload.data.refresh_token,
        verifyRegistrationEmailSuccess: true,
        verifyRegistrationEmailError: null,
      };
    case VERIFY_REGISTRATION_EMAIL_ERROR:
      return {
        ...state,
        verifyRegistrationEmailSuccess: false,
        verifyRegistrationEmailError: action.payload.data,
      };
    case LOGGED_IN:
      return {
        ...state,
        accessToken: action.payload.data.access_token,
        refreshToken: action.payload.data.refresh_token,
        loginError: null,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        accessToken: null,
        refreshToken: null,
        loginError: action.payload.data,
      };
    case ADMIN_SET_TOKENS:
      return {
        ...state,
        accessToken: action.payload.data.access_token,
        refreshToken: action.payload.data.refresh_token,
        loginError: null,
      };
    case CLEAR_LOGIN_ERROR:
      return {
        ...state,
        loginError: null,
      };
    case FETCH_ME:
      if (action.payload.data.checksum && action.payload.data.checksum !== checksum) {
        window.location.reload(false);
      }
      return {
        ...state,
        me: action.payload.data,
        meError: null,
      };
    case SET_ME:
      return {
        ...state,
        me: action.payload.data,
      };
    case FETCH_ME_ERROR:
      return {
        ...state,
        me: null,
        meError: action.payload.data,
      };
    case LOGGING_OUT:
      return {
        ...state,
        loggingOut: true,
      };
    case LOGGED_OUT:
      return {
        ...state,
        loggingOut: false,
        accessToken: null,
        refreshToken: null,
        me: null,
        meError: null,
      };
    case UNAUTHORIZED:
      return {
        ...state,
        unauthorized: true,
      };
    case RESET_UNAUTHORIZED:
      return {
        ...state,
        unauthorized: false,
      };
    case REFRESH_TOKEN:
      return {
        ...state,
        accessToken: action.payload.data.access_token,
        refreshToken: action.payload.data.refresh_token,
        refreshTokenError: null,
      };
    case REFRESH_TOKEN_ERROR:
      return {
        ...state,
        refreshTokenError: action.payload.data,
      };
    case SEND_PASSWORD_RESET_LINK_SUCCESS:
      return {
        ...state,
        sendPasswordResetLinkSuccess: action.payload.data,
        sendPasswordResetLinkError: null,
      };
    case SEND_PASSWORD_RESET_LINK_ERROR:
      return {
        ...state,
        sendPasswordResetLinkSuccess: null,
        sendPasswordResetLinkError: action.payload.data,
      };
    case CLEAR_SEND_PASSWORD_RESET_LINK:
      return {
        ...state,
        sendPasswordResetLinkSuccess: null,
        sendPasswordResetLinkError: null,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordSuccess: action.payload.data,
        resetPasswordError: null,
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPasswordSuccess: null,
        resetPasswordError: action.payload.data,
      };
    case CLEAR_RESET_PASSWORD:
      return {
        ...state,
        resetPasswordSuccess: null,
        resetPasswordError: null,
      };
    case CONFIRMATION_RESENT_SUCCESS:
      return {
        ...state,
        confirmationResentSuccess: action.payload.data,
        confirmationResentError: null,
      };
    case CONFIRMATION_RESENT_ERROR:
      return {
        ...state,
        confirmationResentSuccess: null,
        confirmationResentError: action.payload.data,
      };
    case CLEAR_CONFIRMATION_RESENT:
      return {
        ...state,
        confirmationResentSuccess: null,
        confirmationResentError: null,
      };
    case FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.payload.data,
        countriesError: null,
      };
    case FETCH_COUNTRIES_ERROR:
      return {
        ...state,
        countries: null,
        countriesError: action.payload.data,
      };
    case SOCIAL_LOGIN:
      return {
        ...state,
        accessToken: action.payload.data.access_token,
        refreshToken: action.payload.data.refresh_token,
        isRegistered: action.payload.data.is_registered,
        loginError: null,
      };
    case SOCIAL_LOGIN_ERROR:
      return {
        ...state,
        accessToken: null,
        refreshToken: null,
        isRegistered: false,
        loginError: action.payload.data,
      };
    case TOGGLE_LIVECHAT:
      return {
        ...state,
        liveChatEnabled: action.payload.data.show,
      };
    case CHANGE_SHORT_USERNAME_SUCCESS:
      return {
        ...state,
        changeShortUsernameSuccess: action.payload.data,
        changeShortUsernameError: null,
      };
    case CHANGE_SHORT_USERNAME_ERROR:
      return {
        ...state,
        changeShortUsernameSuccess: null,
        changeShortUsernameError: action.payload.data,
      };
    case CLEAR_CHANGE_SHORT_USERNAME:
      return {
        ...state,
        changeShortUsernameSuccess: null,
        changeShortUsernameError: null,
      };
    case GENERATE_QRCODE_USER_SUCCESS:
      return {
        ...state,
        userQrCodeGeneratedSuccess: action.payload.data,
        userQrCodeGeneratedError: null,
      };
    case GENERATE_QRCODE_USER_ERROR:
      return {
        ...state,
        userQrCodeGeneratedSuccess: null,
        userQrCodeGeneratedError: action.payload.data,
      };
    case CLEAR_GENERATE_QRCODE_USER:
      return {
        ...state,
        userQrCodeGeneratedSuccess: null,
        userQrCodeGeneratedError: null,
      };
    case FETCH_PAGE_BLOCK_ITEMS_LIST:
      return {
        ...state,
        pageBlockItemsList: action.payload.data,
        pageBlockItemsListError: null,
      };
    case FETCH_PAGE_BLOCK_ITEMS_LIST_ERROR:
      return {
        ...state,
        pageBlockItemsList: null,
        pageBlockItemsListError: action.payload.data,
      };
    case CLEAR_FETCH_PAGE_BLOCK_ITEMS_LIST:
      return {
        ...state,
        pageBlockItemsList: null,
        pageBlockItemsListError: null,
      };
    case APPLY_PAGE_BLOCK_ITEM_DRAG:
      return {
        ...state,
        pageBlockItemsDragSuccess: true,
        pageBlockItemsDragError: null,
      };
    case APPLY_PAGE_BLOCK_ITEM_DRAG_ERROR:
      return {
        ...state,
        pageBlockItemsDragSuccess: null,
        pageBlockItemsDragError: action.payload.data,
      };
    case CLEAR_APPLY_PAGE_BLOCK_ITEM_DRAG:
      return {
        ...state,
        pageBlockItemsDragSuccess: null,
        pageBlockItemsDragError: null,
      };
    case CHANGE_EMAIL_SUCCESS:
      return {
        ...state,
        changeEmailSuccess: action.payload.data,
        changeEmailError: null,
      };
    case CHANGE_EMAIL_ERROR:
      return {
        ...state,
        changeEmailSuccess: null,
        changeEmailError: action.payload.data,
      };
    case CLEAR_CHANGE_EMAIL:
      return {
        ...state,
        changeEmailSuccess: null,
        changeEmailError: null,
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordSuccess: action.payload.data,
        changePasswordError: null,
      };
    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        changePasswordSuccess: null,
        changePasswordError: action.payload.data,
      };
    case CLEAR_CHANGE_PASSWORD:
      return {
        ...state,
        changePasswordSuccess: null,
        changePasswordError: null,
      };
    case CREATE_TOTP_SUCCESS:
      return {
        ...state,
        createTtopSuccess: action.payload.data,
        createTtopError: null,
      };
    case CREATE_TOTP_ERROR:
      return {
        ...state,
        createTtopSuccess: null,
        createTtopError: action.payload.data,
      };
    case CLEAR_CREATE_TOTP:
      return {
        ...state,
        createTtopSuccess: null,
        createTtopError: null,
      };
    case DELETE_TOTP_SUCCESS:
      return {
        ...state,
        deleteTtopSuccess: action.payload.data,
        deleteTtopError: null,
      };
    case DELETE_TOTP_ERROR:
      return {
        ...state,
        deleteTtopSuccess: null,
        deleteTtopError: action.payload.data,
      };
    case CLEAR_DELETE_TOTP:
      return {
        ...state,
        deleteTtopSuccess: null,
        deleteTtopError: null,
      };
    case FETCH_TWFA_QRCODE_SUCCESS:
      return {
        ...state,
        twoFactorCode: action.payload.data,
        twoFactorCodeError: null,
      };
    case FETCH_TWFA_QRCODE_ERROR:
      return {
        ...state,
        twoFactorCode: null,
        twoFactorCodeError: action.payload.data,
      };
    case CLEAR_FETCH_TWFA_QRCODE:
      return {
        ...state,
        twoFactorCode: null,
        twoFactorCodeError: null,
      };
    case ENABLE_TOTP_SUCCESS:
      return {
        ...state,
        enableTotpSuccess: action.payload.data,
        enableTotpError: null,
      };
    case ENABLE_TOTP_ERROR:
      return {
        ...state,
        enableTotpSuccess: null,
        enableTotpError: action.payload.data,
      };
    case CLEAR_ENABLE_TOTP:
      return {
        ...state,
        enableTotpSuccess: null,
        enableTotpError: null,
      };
    case FETCH_TWFA_ENABLED_SUCCESS:
      return {
        ...state,
        twoFaEnabled: action.payload.data,
        twoFaEnabledError: null,
      };
    case FETCH_TWFA_ENABLED_ERROR:
      return {
        ...state,
        twoFaEnabled: null,
        twoFaEnabledError: action.payload.data,
      };
    case CLEAR_FETCH_TWFA_ENABLED:
      return {
        ...state,
        twoFaEnabled: null,
        twoFaEnabledError: null,
      };
    case VALIDATE_USERNAME_SUCCESS:
      return {
        ...state,
        validateUsernameSuccess: action.payload.data,
        validateUsernameError: null,
      };
    case VALIDATE_USERNAME_ERROR:
      return {
        ...state,
        validateUsernameSuccess: null,
        validateUsernameError: action.payload.data,
      };
    case CLEAR_VALIDATE_USERNAME:
      return {
        ...state,
        validateUsernameSuccess: null,
        validateUsernameError: null,
      };
    default:
      return state;
  }
};
